import { addDays, kenyaToday, validDateRange } from "../lib/format";

export interface DateRange {
  from: string;
  to: string;
}

export function defaultRange(): DateRange {
  const to = kenyaToday();
  return { from: addDays(to, -29), to };
}

export function DateControls({
  value,
  onChange,
  disabled,
}: {
  value: DateRange;
  onChange: (range: DateRange) => void;
  disabled?: boolean;
}) {
  const today = kenyaToday();

  function setDays(days: number) {
    onChange({ from: addDays(today, -(days - 1)), to: today });
  }

  return (
    <div className="date-controls" aria-label="Report date range">
      <div className="presets">
        <button type="button" onClick={() => setDays(7)} disabled={disabled}>
          7 days
        </button>
        <button type="button" onClick={() => setDays(30)} disabled={disabled}>
          30 days
        </button>
        <button
          type="button"
          onClick={() =>
            onChange({ from: `${today.slice(0, 8)}01`, to: today })
          }
          disabled={disabled}
        >
          Month to date
        </button>
        <button
          type="button"
          onClick={() => onChange({ from: `${today.slice(0, 4)}-01-01`, to: today })}
          disabled={disabled}
        >
          Year to date
        </button>
      </div>
      <div className="custom-range">
        <label>
          From
          <input
            type="date"
            value={value.from}
            max={value.to}
            onChange={(event) => {
              const next = { ...value, from: event.target.value };
              if (validDateRange(next.from, next.to)) onChange(next);
            }}
            disabled={disabled}
          />
        </label>
        <span aria-hidden="true">→</span>
        <label>
          To
          <input
            type="date"
            value={value.to}
            min={value.from}
            max={today}
            onChange={(event) => {
              const next = { ...value, to: event.target.value };
              if (validDateRange(next.from, next.to)) onChange(next);
            }}
            disabled={disabled}
          />
        </label>
      </div>
    </div>
  );
}
